import React from 'react';
import Radium from 'radium';
import RawHtml from './components/RawHtml';
import StyleDecorator from './components/StyleDecorator';
import translate from './locale/translate';
import BrowserDetector from './utils/BrowserDetector';

import UnsupportedBrowserImage from './static/images/sipgate_dachmarke_15_no_support.png';
import { white } from 'material-ui/styles/colors';

const getStyle = () => {
	return {
		headerLogo: {
			width: '267px',
			paddingTop: '31px',
		},
		card: {
			width: '420px',
			background: white,
			paddingLeft: '45px',
			paddingRight: '45px',
			textAlign: 'center',
			paddingBottom: '30px',
		},
	};
};

const UnsupportedBrowserApp = () => {
	const browserDetector = new BrowserDetector();
	const browser = browserDetector.browser.name + ' ' + browserDetector.browser.version;

	const style = getStyle();
	return (
		<div style={style.card} className={'browserunsupportedcard'}>
			<img src={UnsupportedBrowserImage} alt="Browser is unsupported" style={style.headerLogo} />
			<RawHtml
				inner={translate('BROWSER_UNSUPPORTED_TITLE', { BROWSER: browser })}
				tag={'h3'}
			/>
			<RawHtml
				inner={translate('BROWSER_UNSUPPORTED_BODY')}
				tag={'p'}
			/>
		</div>
	);
};

UnsupportedBrowserApp.propTypes = {
	visible: React.PropTypes.bool,
	mediaQueries: React.PropTypes.object,
};

export default StyleDecorator(Radium(UnsupportedBrowserApp));



// WEBPACK FOOTER //
// ./src/UnsupportedBrowserApp.js